import { City } from './city'

export class BranchRequest {
  documentImageFile: string;
  branchRequestId: string;
  branchName: string;
  location: string;
  address: string;
  phoneNumber: string;
  mobileNumber: string;
  nationalCode: string;
  hasSubBranch: boolean;
  userCount: number;
  fname: string;
  lname: string;
  genderId: number ;
  activityScope: string;
  status: boolean;
  foundedDate: any;
  userPicId: string;
  transferCapability: boolean;
  useComputer: boolean;
  city: City
  cityId: number;
  userPic: File;
  lastModifiedDate: string;
  constructor() {
    this.city = new City();
  }
}
